import React from "react";
import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { color } from "@/styles/theme";

type Props = {
  url: string;
};

export const UrlLabel = (props: Props) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          URL
        </Font>
      </div>
      <div css={inputWrapper}>
        <Font>
          <a css={link} href={props.url}>
            {props.url}
          </a>
        </Font>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "15px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  paddingTop: "8px",
  flex: 1,
});

const link = css({
  color: color.link,
  ":hover": {
    textDecoration: "underline",
    opacity: 0.7,
    cursor: "pointer",
  },
});
